"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M16 2a16 16 0 1 0 16 16A16 16 0 0 0 16 2zm10.666 9.08L14.018 27.341a1.208 1.208 0 0 1-.875.461h-.072a1.2 1.2 0 0 1-.85-.352l-7.785-7.793a1.2 1.2 0 0 1 0-1.7l1.326-1.325a1.2 1.2 0 0 1 1.7 0l5.338 5.349L23.315 8.473A1.2 1.2 0 0 1 25 8.263L26.455 9.4a1.2 1.2 0 0 1 .211 1.68z" })
);

